/**
 * React Query hook for fetching config file overrides.
 * Returns the list of overrides for a given config file within a project.
 */

import { useQuery } from '@tanstack/react-query';

import type { ConfigFileOverride } from '@/api/configuration';
import { listConfigFileOverrides } from '@/api/configuration';
import { queryKeys } from '@/modules/query/query-keys';

/**
 * Fetches config file overrides for the specified project and config file.
 * Only executes the query when both projectKey and configFileId are truthy.
 */
export function useConfigFileOverrides(projectKey: string, configFileId: string) {
  return useQuery<ConfigFileOverride[]>({
    queryKey: queryKeys.configuration.configFileOverrides(projectKey, configFileId),
    queryFn: () => listConfigFileOverrides(projectKey, configFileId),
    enabled: !!projectKey && !!configFileId,
    retry: 1,
  });
}
